import { useSubtitleTasks } from "~/store/useSubtitleTasks";

// A tab keeps its stores across sign-out, so one account's task list must not
// reach whoever signs in next. A guest who signs in keeps theirs. The batch
// record is tagged with its owner instead (see useMediaBatch).
export default defineNuxtPlugin(() => {
  const user = useSupabaseUser();
  watch(
    // JWT claims: the user id is `sub`.
    () => user.value?.sub ?? null,
    (id, previous) => {
      if (previous && id !== previous) useSubtitleTasks().resetForAccountChange();
    }
  );
});
